/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Model_Row3_SkillInputs */

const en_mk_model_row3_skill = /** @type {(inputs: Mk_Model_Row3_SkillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summarize financial reports`)
};

const id_mk_model_row3_skill = /** @type {(inputs: Mk_Model_Row3_SkillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekap laporan keuangan`)
};

/**
* | output |
* | --- |
* | "Summarize financial reports" |
*
* @param {Mk_Model_Row3_SkillInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_model_row3_skill = /** @type {((inputs?: Mk_Model_Row3_SkillInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Model_Row3_SkillInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_model_row3_skill(inputs)
	return en_mk_model_row3_skill(inputs)
});